<!-- 日志详情页面 -->
<div class="log-detail-container" [testId]="'log-detail-container'">
  <!-- 页头 -->
  <div class="page-header" [testId]="'page-header'">
    <div class="breadcrumb-container" [testId]="'breadcrumb-container'">
      <nz-breadcrumb [testId]="'breadcrumb'">
        <nz-breadcrumb-item [testId]="'breadcrumb-home'">{{ 'common.home' | i18n }}</nz-breadcrumb-item>
        <nz-breadcrumb-item [testId]="'breadcrumb-management'">{{ 'log.log-management' | i18n }}</nz-breadcrumb-item>
        <nz-breadcrumb-item [testId]="'breadcrumb-list'"
          ><a [routerLink]="['/logs']" [testId]="'breadcrumb-list-link'">{{ 'log.log-list' | i18n }}</a></nz-breadcrumb-item
        >
        <nz-breadcrumb-item [testId]="'breadcrumb-detail'">{{ 'log.log-detail' | i18n }}</nz-breadcrumb-item>
      </nz-breadcrumb>
    </div>

    <div class="header-title" [testId]="'header-title'">
      <h2 [testId]="'detail-title'"
        >{{ 'log.log-detail' | i18n }} <span class="log-id" [testId]="'log-id'">ID: {{ id }}</span></h2
      >
      <div class="header-actions" [testId]="'header-actions'">
        <button nz-button (click)="goBack()" [testId]="'back-button'">
          <nz-icon nzType="arrow-left" [testId]="'back-icon'" />{{ 'common.back' | i18n }}
        </button>
      </div>
    </div>
  </div>

  <!-- 加载状态 -->
  <nz-spin [nzSpinning]="loading" nzTip="{{ 'common.loading' | i18n }}" [testId]="'loading-spinner'">
    <ng-container *ngIf="logDetail; else emptyData">
      <!-- 基本信息 -->
      <nz-card [nzTitle]="'log.basic-info' | i18n" [nzBordered]="false" class="detail-card" [testId]="'basic-info-card'">
        <div nz-row [nzGutter]="24" [testId]="'basic-info-row'">
          <div nz-col [nzXs]="24" [nzSm]="12" [nzMd]="8" [testId]="'trace-id-col'">
            <div class="detail-item" [testId]="'trace-id-item'">
              <span class="detail-label" [testId]="'trace-id-label'">Trace ID:</span>
              <span class="detail-value" [testId]="'trace-id-value'">{{ logDetail.traceId }}</span>
            </div>
          </div>
          <div nz-col [nzXs]="24" [nzSm]="12" [nzMd]="8" [testId]="'request-time-col'">
            <div class="detail-item" [testId]="'request-time-item'">
              <span class="detail-label" [testId]="'request-time-label'">{{ 'log.request-time' | i18n }}:</span>
              <span class="detail-value" [testId]="'request-time-value'">{{
                logDetail.requestTime | date: 'yyyy-MM-dd HH:mm:ss.SSS'
              }}</span>
            </div>
          </div>
          <div nz-col [nzXs]="24" [nzSm]="12" [nzMd]="8" [testId]="'response-time-col'">
            <div class="detail-item" [testId]="'response-time-item'">
              <span class="detail-label" [testId]="'response-time-label'">{{ 'log.response-time' | i18n }}:</span>
              <span class="detail-value" [testId]="'response-time-value'">{{
                logDetail.responseTime | date: 'yyyy-MM-dd HH:mm:ss.SSS'
              }}</span>
            </div>
          </div>
          <div nz-col [nzXs]="24" [nzSm]="12" [nzMd]="8" [testId]="'description-col'">
            <div class="detail-item" [testId]="'description-item'">
              <span class="detail-label" [testId]="'description-label'">{{ 'log.description' | i18n }}:</span>
              <span class="detail-value" [testId]="'description-value'">{{ logDetail.description }}</span>
            </div>
          </div>
          <div nz-col [nzXs]="24" [nzSm]="12" [nzMd]="8" [testId]="'token-id-col'">
            <div class="detail-item" [testId]="'token-id-item'">
              <span class="detail-label" [testId]="'token-id-label'">Token ID:</span>
              <span class="detail-value" [testId]="'token-id-value'">{{ logDetail.tokenId }}</span>
            </div>
          </div>
          <div nz-col [nzXs]="24" [nzSm]="12" [nzMd]="8" [testId]="'node-col'">
            <div class="detail-item" [testId]="'node-item'">
              <span class="detail-label" [testId]="'node-label'">{{ 'log.node' | i18n }}:</span>
              <span class="detail-value" [testId]="'node-value'">{{ logDetail.node }}</span>
            </div>
          </div>
          <div nz-col [nzXs]="24" [nzSm]="12" [nzMd]="8" [testId]="'status-col'">
            <div class="detail-item" [testId]="'status-item'">
              <span class="detail-label" [testId]="'status-label'">{{ 'log.status' | i18n }}:</span>
              <nz-tag [nzColor]="logDetail.hasError === true ? 'error' : 'success'" [testId]="'status-tag'">
                {{ logDetail.hasError === true ? ('log.failed' | i18n) : ('log.success' | i18n) }}
              </nz-tag>
            </div>
          </div>
        </div>
      </nz-card>

      <!-- 请求信息 -->
      <nz-card [nzTitle]="'log.request-info' | i18n" [nzBordered]="false" class="detail-card" [testId]="'request-info-card'">
        <div nz-row [nzGutter]="24" [testId]="'request-info-row'">
          <div nz-col [nzXs]="24" [nzSm]="12" [nzMd]="8" [testId]="'request-path-col'">
            <div class="detail-item" [testId]="'request-path-item'">
              <span class="detail-label" [testId]="'request-path-label'">{{ 'log.request-path' | i18n }}:</span>
              <span class="detail-value" [testId]="'request-path-value'">{{ logDetail.requestPath }}</span>
            </div>
          </div>
          <div nz-col [nzXs]="24" [nzSm]="12" [nzMd]="8" [testId]="'request-url-col'">
            <div class="detail-item" [testId]="'request-url-item'">
              <span class="detail-label" [testId]="'request-url-label'">{{ 'log.request-url' | i18n }}:</span>
              <span class="detail-value" [testId]="'request-url-value'">{{ logDetail.url }}</span>
            </div>
          </div>
          <div nz-col [nzXs]="24" [nzSm]="12" [nzMd]="8" [testId]="'request-method-col'">
            <div class="detail-item" [testId]="'request-method-item'">
              <span class="detail-label" [testId]="'request-method-label'">{{ 'log.request-method' | i18n }}:</span>
              <span class="detail-value" [testId]="'request-method-value'">{{ logDetail.method }}</span>
            </div>
          </div>
          <div nz-col [nzXs]="24" [nzSm]="12" [nzMd]="8" [testId]="'ip-address-col'">
            <div class="detail-item" [testId]="'ip-address-item'">
              <span class="detail-label" [testId]="'ip-address-label'">{{ 'log.ip-address' | i18n }}:</span>
              <span class="detail-value" [testId]="'ip-address-value'">{{ logDetail.ip }}</span>
            </div>
          </div>
          <div nz-col [nzXs]="24" [nzSm]="12" [nzMd]="8" [testId]="'account-id-col'">
            <div class="detail-item" [testId]="'account-id-item'">
              <span class="detail-label" [testId]="'account-id-label'">{{ 'log.account-id' | i18n }}:</span>
              <span class="detail-value" [testId]="'account-id-value'">{{ logDetail.accountId }}</span>
            </div>
          </div>
          <div nz-col [nzXs]="24" [nzSm]="12" [nzMd]="8" [testId]="'account-name-col'">
            <div class="detail-item" [testId]="'account-name-item'">
              <span class="detail-label" [testId]="'account-name-label'">{{ 'log.account-name' | i18n }}:</span>
              <span class="detail-value" [testId]="'account-name-value'">{{ logDetail.name }}</span>
            </div>
          </div>
          <div nz-col [nzXs]="24" [nzSm]="12" [nzMd]="8" [testId]="'device-id-col'">
            <div class="detail-item" [testId]="'device-id-item'">
              <span class="detail-label" [testId]="'device-id-label'">{{ 'log.device-id' | i18n }}:</span>
              <span class="detail-value" [testId]="'device-id-value'">{{ logDetail.uniqueId }}</span>
            </div>
          </div>
          <div nz-col [nzXs]="24" [nzSm]="12" [nzMd]="8" [testId]="'channel-source-col'">
            <div class="detail-item" [testId]="'channel-source-item'">
              <span class="detail-label" [testId]="'channel-source-label'">{{ 'log.channel-source' | i18n }}:</span>
              <span class="detail-value" [testId]="'channel-source-value'">{{ logDetail.channel }}</span>
            </div>
          </div>
          <div nz-col [nzXs]="24" [nzSm]="12" [nzMd]="8" [testId]="'tenant-id-col'">
            <div class="detail-item" [testId]="'tenant-id-item'">
              <span class="detail-label" [testId]="'tenant-id-label'">{{ 'log.tenant-id' | i18n }}:</span>
              <span class="detail-value" [testId]="'tenant-id-value'">{{ logDetail.tenantId }}</span>
            </div>
          </div>
          <div nz-col [nzXs]="24" [nzSm]="12" [nzMd]="8" [testId]="'user-id-col'">
            <div class="detail-item" [testId]="'user-id-item'">
              <span class="detail-label" [testId]="'user-id-label'">{{ 'log.user-id' | i18n }}:</span>
              <span class="detail-value" [testId]="'user-id-value'">{{ logDetail.employeeId }}</span>
            </div>
          </div>
          <div nz-col [nzXs]="24" [nzSm]="12" [nzMd]="8" [testId]="'processing-time-col'">
            <div class="detail-item" [testId]="'processing-time-item'">
              <span class="detail-label" [testId]="'processing-time-label'">{{ 'log.processing-time' | i18n }}:</span>
              <span class="detail-value" [testId]="'processing-time-value'">{{ logDetail.timeCost }} ms</span>
            </div>
          </div>
        </div>
      </nz-card>

      <!-- 请求参数 -->
      <nz-card [nzTitle]="'log.request-params' | i18n" [nzBordered]="false" class="detail-card" [testId]="'request-params-card'">
        <nz-tabset [testId]="'request-params-tabset'">
          <nz-tab nzTitle="{{ 'log.request-body' | i18n }}" [testId]="'request-body-tab'">
            <ng-container *ngIf="this.logDetail.requestText !== null; else emptyBody">
              <!-- 替换简单span为更适合代码显示的pre元素 -->
              <div class="json-container" [testId]="'request-json-container'">
                <button
                  nz-button
                  nzType="text"
                  nzSize="small"
                  class="copy-btn"
                  nz-tooltip
                  nzTooltipTitle="{{ 'log.copy-content' | i18n }}"
                  (click)="copyToClipboard(logDetail.requestText)"
                  [testId]="'request-copy-btn'"
                >
                  <span nz-icon nzType="copy" [testId]="'request-copy-icon'"></span>
                </button>
                <pre class="json-content" [testId]="'request-json-content'">{{ formatJson(logDetail.requestText) }}</pre>
              </div>
            </ng-container>
            <ng-template #emptyBody>
              <nz-empty [nzNotFoundContent]="noRequestContent" [testId]="'request-empty'">
                <ng-template #noRequestContent>
                  <span [testId]="'request-empty-text'">{{ 'log.no-request-body' | i18n }}</span>
                </ng-template>
              </nz-empty>
            </ng-template>
          </nz-tab>
          <nz-tab nzTitle="{{ 'log.request-headers' | i18n }}" [testId]="'request-headers-tab'">
            <ng-container *ngIf="this.logDetail.requestHeader !== null; else emptyHeaders">
              <div class="json-container" [testId]="'request-headers-json-container'">
                <div class="json-actions" [testId]="'request-headers-actions'">
                  <button
                    nz-button
                    nzSize="small"
                    class="decode-format-btn"
                    (click)="toggleRequestHeaderDecoded()"
                    [testId]="'request-headers-decode-btn'"
                  >
                    <span nz-icon nzType="code" [testId]="'request-headers-decode-icon'"></span>
                    {{ (requestHeaderDecoded ? 'log.show-original' : 'log.decode-format') | i18n }}
                  </button>
                  <button
                    nz-button
                    nzType="text"
                    nzSize="small"
                    nz-tooltip
                    nzTooltipTitle="{{ 'log.copy-content' | i18n }}"
                    (click)="copyToClipboard(formatJson(logDetail.requestHeader, requestHeaderDecoded))"
                    [testId]="'request-headers-copy-btn'"
                  >
                    <span nz-icon nzType="copy" [testId]="'request-headers-copy-icon'"></span>
                  </button>
                </div>
                <pre class="json-content request-header-content" [testId]="'request-headers-json-content'">{{
                  formatJson(logDetail.requestHeader, requestHeaderDecoded)
                }}</pre>
              </div>
            </ng-container>
            <ng-template #emptyHeaders>
              <nz-empty [nzNotFoundContent]="noRequestHeadersContent" [testId]="'request-headers-empty'">
                <ng-template #noRequestHeadersContent>
                  <span [testId]="'request-headers-empty-text'">{{ 'log.no-request-headers' | i18n }}</span>
                </ng-template>
              </nz-empty>
            </ng-template>
          </nz-tab>
        </nz-tabset>
      </nz-card>

      <!-- 响应结果 -->
      <nz-card [nzTitle]="'log.response-result' | i18n" [nzBordered]="false" class="detail-card" [testId]="'response-result-card'">
        <nz-tabset [testId]="'response-result-tabset'">
          <nz-tab nzTitle="{{ 'log.response-body' | i18n }}" [testId]="'response-body-tab'">
            <ng-container *ngIf="logDetail.responseText !== null; else emptyResponseBody">
              <!-- 替换简单span为更适合代码显示的pre元素 -->
              <div class="json-container" [testId]="'response-json-container'">
                <button
                  nz-button
                  nzType="text"
                  nzSize="small"
                  class="copy-btn"
                  nz-tooltip
                  nzTooltipTitle="{{ 'log.copy-content' | i18n }}"
                  (click)="copyToClipboard(logDetail.responseText)"
                  [testId]="'response-copy-btn'"
                >
                  <span nz-icon nzType="copy" [testId]="'response-copy-icon'"></span>
                </button>
                <pre class="json-content" [testId]="'response-json-content'">{{ formatJson(logDetail.responseText) }}</pre>
              </div>
            </ng-container>
            <ng-template #emptyResponseBody>
              <nz-empty [nzNotFoundContent]="noResponseContent" [testId]="'response-empty'">
                <ng-template #noResponseContent>
                  <span [testId]="'response-empty-text'">{{ 'log.no-response-body' | i18n }}</span>
                </ng-template>
              </nz-empty>
            </ng-template>
          </nz-tab>
        </nz-tabset>
      </nz-card>

      <!-- 错误信息 -->
      <nz-card
        [nzTitle]="'log.error-info' | i18n"
        [nzBordered]="false"
        class="detail-card"
        *ngIf="logDetail.errorStrace"
        [testId]="'error-info-card'"
      >
        <nz-collapse [nzGhost]="true" [testId]="'error-collapse'">
          <nz-collapse-panel
            *ngIf="logDetail.errorStrace"
            [nzHeader]="'log.stack-trace' | i18n"
            [nzActive]="true"
            [testId]="'error-collapse-panel'"
          >
            <pre class="error-message" [testId]="'error-message'">{{ logDetail.errorStrace }}</pre>
          </nz-collapse-panel>
        </nz-collapse>
      </nz-card>

      <!-- 设备信息 -->
      <nz-card [nzTitle]="'log.device-info' | i18n" [nzBordered]="false" class="detail-card" [testId]="'device-info-card'">
        <div nz-row [nzGutter]="24" [testId]="'device-info-row'">
          <div nz-col [nzXs]="24" [nzSm]="12" [nzMd]="8" [testId]="'device-name-col'">
            <div class="detail-item" [testId]="'device-name-item'">
              <span class="detail-label" [testId]="'device-name-label'">{{ 'log.device-name' | i18n }}:</span>
              <span class="detail-value" [testId]="'device-name-value'">{{ logDetail.deviceName }}</span>
            </div>
          </div>
          <div nz-col [nzXs]="24" [nzSm]="12" [nzMd]="8" [testId]="'bundle-id-col'">
            <div class="detail-item" [testId]="'bundle-id-item'">
              <span class="detail-label" [testId]="'bundle-id-label'">{{ 'log.bundle-id' | i18n }}:</span>
              <span class="detail-value" [testId]="'bundle-id-value'">{{ logDetail.bundleId }}</span>
            </div>
          </div>
          <div nz-col [nzXs]="24" [nzSm]="12" [nzMd]="8" [testId]="'version-col'">
            <div class="detail-item" [testId]="'version-item'">
              <span class="detail-label" [testId]="'version-label'">{{ 'log.version' | i18n }}:</span>
              <span class="detail-value" [testId]="'version-value'">{{ logDetail.version }}</span>
            </div>
          </div>
          <div nz-col [nzXs]="24" [nzSm]="12" [nzMd]="8" [testId]="'os-type-col'">
            <div class="detail-item" [testId]="'os-type-item'">
              <span class="detail-label" [testId]="'os-type-label'">{{ 'log.os-type' | i18n }}:</span>
              <span class="detail-value" [testId]="'os-type-value'">{{ logDetail.osType }}</span>
            </div>
          </div>
        </div>
      </nz-card>

      <!-- 关联子项列表 -->
      <nz-card [nzTitle]="'log.related-items' | i18n" [nzBordered]="false" class="detail-card" [testId]="'related-items-card'">
        <ng-container *ngIf="relatedItems && relatedItems.length > 0; else noRelatedItems">
          <log-table
            [data]="relatedItems"
            [loading]="relatedItemsLoading"
            [total]="relatedItemsTotal"
            [pageSize]="relatedItemsPageSize"
            [pageIndex]="relatedItemsPageIndex"
            [expandable]="true"
            [hideHeader]="false"
            [indentLevel]="0"
            (pageIndexChange)="onRelatedItemsPageIndexChange($event)"
            (pageSizeChange)="onRelatedItemsPageSizeChange($event)"
            (expandChange)="loadChildItems($event)"
            (viewDetail)="viewRelatedItem($event)"
            [testId]="'related-items-table'"
          />
        </ng-container>

        <ng-template #noRelatedItems>
          <div class="empty-related-items" [testId]="'empty-related-items'">
            <nz-empty [nzNotFoundContent]="'log.no-related-items' | i18n" [nzNotFoundImage]="'simple'" [testId]="'related-items-empty'">
              <div class="ant-empty-footer" [testId]="'related-items-empty-footer'">
                <span class="empty-tip" [testId]="'related-items-empty-tip'">{{ 'log.no-related-operations' | i18n }}</span>
              </div>
            </nz-empty>
          </div>
        </ng-template>
      </nz-card>
    </ng-container>

    <ng-template #emptyData>
      <nz-empty *ngIf="!loading" [nzNotFoundContent]="notFoundContent">
        <ng-template #notFoundContent>
          <div class="empty-container">
            <span nz-icon nzType="file-exclamation" nzTheme="outline" class="empty-icon"></span>
            <p class="ant-empty-description">{{ 'log.data-not-found' | i18n }}</p>
            <div class="ant-empty-footer">
              <button nz-button nzType="primary" (click)="goBack()" testId="log-detail-empty-back-button">{{
                'common.back-to-list' | i18n
              }}</button>
            </div>
          </div>
        </ng-template>
      </nz-empty>
    </ng-template>
  </nz-spin>
</div>
